<template>
  <div class="row">
    <div class="col-12">
      <div class="card-header-actions">
        <div class="col-lg-8 col-md-8 col-12 card-header-filter-box">
          <div class="row align-items-end">
            <div class="col-12 col-md-3 card-header-select-box pr-sm-2">
              <div class="form-group">
                <label>{{ $t("fitment.fitmentType") }}</label>
                <select class="form-control"
                        v-model="filter.fitmentType" @change="onPageChange">
                  <option :value="option.key" v-for="option in fitmentTypes" :key="option.key">
                    {{ option.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
          <button class="all-btn add-btn m-0" v-if="hasPermission('SETTINGS_BUILDING_MARKET_ANALYSIS_ADD')"
                  @click="showFitmentMarketAnalysisModal(null)">
            {{ $t("action.add") }}
          </button>
          <button class="all-btn m-0 ml-3" @click="onSearch">
            <i class="fa fa-search"></i>
            <span>{{ $t('main.search') }}</span>
          </button>
        </div>
      </div>

    </div>
    <div class="col-12">
      <div class="table-wrapper">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>#</th>
<!--            <th>Вилоят</th>-->
            <th>Сана</th>
            <th>Текст</th>
            <th>Илова</th>
            <th class="text-center">{{ $t("realEstate.field.action") }}</th>
          </tr>
          </thead>
          <tbody v-if="!loading && results && results.data">
          <tr v-for="result in results.data" :key="result.id">
            <td>{{ result.id }}</td>
<!--            <td>{{ result.data.fitmentType.name }}</td>-->
            <td>{{ result.data.analysisDate }}</td>
            <td>
              <span v-html="result.data.description"></span>
            </td>
            <td v-if="result.applications">
              <div v-for="(photo) in result.applications" :key="photo.id" class="mb-2">
                <img :src="photo.filePath" id="appImage" style="max-width: 100px;max-height: 100px; cursor: pointer;"
                     v-if="photo && photo.filePath" @click="onClickPhoto(photo)"/>
              </div>
            </td>
            <td>
              {{ new Date(result.createdDate) | dateFormat('DD/MM/YYYY HH:mm') }}
            </td>
            <td class="td-actions text-center">
              <button class="all-btn edit-btn table-action" data-original-title="Edit"
                      v-if="hasPermission('SETTINGS_FITMENT_MARKET_ANALYSIS_ADD')"
                      @click="showFitmentMarketAnalysisModal(result)">
                <i class="fa fa-edit"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="text-center">
        <div class="loader mt-5 mb-5" v-if="loading"></div>
        <span class="no-data mt-5 mb-5"
              v-if="!loading && results && results.data && results.data.length===0">{{
            $t("messages.list.empty")
          }}</span>
      </div>
      <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
        <div class="col-12 pt-3 pb-3">
          <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size"
                        @change="onPageChange">
          </b-pagination>
        </div>
      </div>
    </div>
    <FitmentMarketAnalysisEditModal @change="initList"></FitmentMarketAnalysisEditModal>
  </div>
</template>

<script>
import FitmentMarketAnalysisEditModal from "@/views/config/market-analysis/FitmentMarketAnalysisEditModal";
import initFilterModel from '@/shared/filter';
import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
import {FITMENT_TYPE} from "@/shared/constants/fitment";

export default {
  name: "FitmentMarketAnalysisList",
  components: {
    FitmentMarketAnalysisEditModal,
    'b-pagination': bPagination
  },
  data() {
    return {
      loading: false,
      filter: initFilterModel(),
      filterProvince: initFilterModel(),
      results: null,
      fitmentTypes: FITMENT_TYPE,
      provinces: []
    }
  },
  methods: {
    initList() {
      this.loading = true;
      const vm = this;
      this.$http.post('dictionary/fitment/market-analysis/list/FITMENT_MARKET_ANALYSIS', this.filter)
          .then(res => {
            this.results = res.data;
            vm.loading = false;
          }, err => {
            console.log(err);
            vm.loading = false;
          });
    },
    showFitmentMarketAnalysisModal(data) {
      this.$eventBus.$emit('showFitmentMarketAnalysisEditModal', data)
    },
    onClickPhoto(file) {
      window.open(file.filePath, '_blank');
    },
    onPageChange(page) {
      this.filter.page.page = page;
      this.initList();
    },
    onSearch() {
      this.initList();
    }
  },
  created() {
    this.initList();
  }
}
</script>

<style scoped>

</style>